import type { ContentItem, Doc } from "@smartsuite/smartdoc";

/**
 * Text nodes may carry a `link` mark whose `href` is a serialized nested SmartDoc
 * (e.g. URL-with-pills). Maps each direct child under each top-level block of that
 * nested doc through `visit`. Non-JSON hrefs, plain URLs, and non-doc JSON are unchanged.
 */
export function updateNestedSmartDocInLinkMarks(
  content: ContentItem,
  visit: (node: ContentItem) => ContentItem,
): ContentItem {
  if (content.marks === undefined || content.marks.length === 0) {
    return content;
  }

  const updatedMarks = content.marks.map((mark) => {
    if (mark.type !== "link" || !mark.attrs?.href) return mark;
    try {
      const hrefDoc: Doc = JSON.parse(String(mark.attrs.href));
      if (hrefDoc?.type !== "doc") return mark;
      const processedContent = hrefDoc.content.map((block: ContentItem) => ({
        ...block,
        content: (block.content ?? []).map((node: ContentItem) => visit(node)),
      }));
      return {
        ...mark,
        attrs: {
          ...mark.attrs,
          href: JSON.stringify({ ...hrefDoc, content: processedContent }),
        },
      };
    } catch {
      return mark;
    }
  });

  return { ...content, marks: updatedMarks };
}
